import { UninstallAppScreen } from './uninstallAppScreen';

const props = [];

export const UninstallAppScreenDirective = (reactDirective) => reactDirective(UninstallAppScreen, props);
UninstallAppScreenDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('uninstallAppScreen', UninstallAppScreenDirective);
